import { useEffect, useState } from 'react';
import { ActivityIndicator, Pressable, Text, View } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { entrarGrupo, infoConvite, recarregarGrupos } from '../lib/grupos';
import { limparConvite, pegarConvite } from '../lib/convite';
import { abrirGrupos } from '../components/Grupos';
import { C, aba } from '../components/theme';
import { Btn } from '../components/ui';
import type { AbaId } from '../store/types';
import { t } from '../lib/i18n';
export { ErrorBoundary } from '../components/Falha';

/** Tela do convite (com a pessoa já dentro da conta): mostra o grupo e pede a confirmação para entrar. */
export default function Convite() {
  const router = useRouter();
  const p = useLocalSearchParams<{ c?: string }>();
  const [codigo, setCodigo] = useState<string | null>(p.c ? String(p.c).toUpperCase() : null);
  const [info, setInfo] = useState<{ nome: string; aba: AbaId; membros: number } | null | undefined>(undefined);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!codigo) pegarConvite().then(c => setCodigo(c)); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (codigo) infoConvite(codigo).then(setInfo).catch(e => { setMsg(String(e?.message ?? e)); setInfo(null); }); }, [codigo]);
  const sair = () => { limparConvite(); router.replace('/'); };
  async function entrar() {
    if (!codigo) return;
    setBusy(true);
    try { const g = await entrarGrupo(codigo); await limparConvite();
      // escritório: cai direto nele; os outros grupos abrem a lista de grupos
      if (g.aba === 'escritorio') { await recarregarGrupos(); router.replace({ pathname: '/aba/[id]', params: { id: 'escritorio', item: g.id } } as any); }
      // 0.71 (texto 09 K5): grupo de estudos cai direto no fichário compartilhado
      else if (g.aba === 'estudos') { await recarregarGrupos(); router.replace({ pathname: '/aba/[id]', params: { id: 'estudos', item: 'grupo:' + g.id } } as any); }
      else { router.replace('/'); setTimeout(() => abrirGrupos(), 500); } }
    catch (e: any) { setMsg(String(e?.message ?? e)); }
    finally { setBusy(false); }
  }
  return (
    <View style={{ flex: 1, backgroundColor: C.bg, justifyContent: 'center', padding: 28, gap: 14 }}>
      <Text style={{ fontSize: 52, textAlign: 'center' }}>{info ? aba(info.aba)?.icon ?? '👥' : '👥'}</Text>
      {info === undefined && codigo ? <ActivityIndicator color="#8B5CF6" /> : info ? (<>
        <Text style={{ color: C.sub, textAlign: 'center' }}>{t('Você foi convidado para o grupo')}</Text>
        <Text style={{ color: C.text, fontSize: 24, fontWeight: '800', textAlign: 'center' }}>{info.nome}</Text>
        <Text style={{ color: C.sub, textAlign: 'center' }}>{[aba(info.aba)?.nome, t('{n} pessoa(s)', { n: info.membros })].filter(Boolean).join(' · ')}</Text>
        <Text style={{ color: C.mute, fontSize: 12, textAlign: 'center' }}>{t('O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.')}</Text>
        <Btn cor="#8B5CF6" label={busy ? t('Aguarde...') : t('Entrar no grupo')} disabled={busy} onPress={entrar} />
      </>) : <Text style={{ color: C.text, fontSize: 18, fontWeight: '700', textAlign: 'center' }}>{t('Convite inválido ou trocado pelo administrador. Peça um link novo.')}</Text>}
      {!!msg && <Text style={{ color: C.danger, textAlign: 'center' }}>{msg}</Text>}
      <Pressable onPress={sair} style={{ alignItems: 'center', padding: 8 }}><Text style={{ color: C.sub }}>{t('Agora não')}</Text></Pressable>
    </View>
  );
}
